import React from 'react';
import JoinScreen from './JoinScreen';
import useLocationConnection from './useLocationConnection';

export default function LocationInactive() {
  const { pending, error, requestLocation } = useLocationConnection();
  return <JoinScreen pending={pending} error={error} onConnect={requestLocation} />;
}
